<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()"></a>
  </div>
  <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
  </nb-select>
</div>

<div class="header-container">
    <h6>{{ displayName }} </h6><h6 *ngIf="isAdminOverride" style="margin-left: 10px;"> (SuperAdmin)</h6>
    <img class="logo_img" [src]="logoUrl">
</div>

<div class="header-container">
  <nb-actions size="small">
    <nb-action class="user-action" [nbContextMenu]="menuItems$ | async" [nbContextMenuTag]="contextMenuTag">
      <nb-user [name]="userName$ | async"  size="medium" showInitials="true" showTitle="false" showName="true"></nb-user>
    </nb-action>
  </nb-actions>
</div>
